
import { useNavigate } from "react-router-dom";
import "./ServiceHomeHeroSection.css";

const ServiceHomeHeroSection = ({
  serviceData,
  serviceName,
  backgroundImage,
  title,
  subtitle,
  quoteButtonText = "Get Quote",
  showContact = true,
  customPath,
}) => {
  const navigate = useNavigate();

  const handleGetQuote = () => {
    if (customPath) {
      navigate(customPath);
      return;
    }

    // Safety check
    if (!serviceData && !serviceName) {
      console.warn("Service data not available");
      return;
    }

    navigate("/personalizedBudgetPage", {
      state: {
        serviceId: serviceData?._id,
        serviceName: serviceData?.serviceName || serviceName,
      },
    });
  };

  console.log({ serviceData, serviceName, backgroundImage });

  return (
    <div
      className="automotive-hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="automotive-overlay"></div>

      <div className="automotive-content">
        <h1 className="automotive-title">{title}</h1>

        {subtitle && (
          <p className="automotive-subtitle">{subtitle}</p>
        )}

        <div className="automotive-buttons">
          <button
            className="auto-btn auto-btn-quote"
            onClick={handleGetQuote}
            disabled={!customPath && !serviceData && !serviceName}
          >
            {quoteButtonText}
          </button>

          {showContact && (
            <button
              className="auto-btn auto-btn-contact"
              onClick={() => navigate("/contact-us")}
            >
              Contact Us
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
  
export default ServiceHomeHeroSection;
